module.exports = __webpack_public_path__ + "static/ropa_main_bg-46ef19632c1c318d437b459235095dff.jpg";